import axiosInstance from "@/api/axiosInstance";
import { MetricWithTrend } from "@/modules/coaching/types";

export interface GetCompanyMetricsResponse {
  companyId: number;
  metrics: MetricWithTrend[];
  healthScore: number;
  healthIndicator: 'green' | 'yellow' | 'red';
  healthScoreBreakdown: Array<{
    metricName: string;
    value: number;
    normalizedValue: number;
    weight: number;
    contribution: number;
  }>;
}

export const getCompanyMetrics = async (
  companyId: number
): Promise<GetCompanyMetricsResponse> => {
  const response = await axiosInstance.get(
    `/api/private/coaching/companies/${companyId}/metrics`
  );
  return response.data;
};
